import React from "react";
import { TurnrTableCell } from "../TurnrTableSmart.jsx";
import SetBrandLink from "../../SetBrandLink.jsx";

export function getTableHeadBrand({ appProps, hide = "xl", ...rest } = {}) {
    return {
        id: "merchantBrand.name",
        label: "Brand",
        hide: !!appProps?.selectedBrandId || hide,
        sortable: false,
        ...rest,
    };
}

export function TableCellBrand({ appProps, entity, brand = entity?.shop || entity?.merchantBrand || entity?.order?.merchantBrand, ...rest }) {
    if (appProps?.selectedBrandId) {
        return null;
    }

    return (
        <TurnrTableCell tight={true} {...rest} style={{ minWidth: "120px", ...rest?.style }}>
            <SetBrandLink appProps={appProps} brand={brand} />
        </TurnrTableCell>
    );
}
